/* src/app/modules/print-cards/components/print-labels/backgrounds/custom-labels-2x4/base-inventory-label-stack-background/base-inventory-label-stack-background.component.scss */
/*# sourceMappingURL=base-inventory-label-stack-background.component.css.map */
